import { Injectable } from "@angular/core";
import { SearchService } from "../../search/search.service";
import { LoaderEnabled } from '../../components/loader/loader.service';
import { Observable } from 'rxjs/Observable';
import { PagedData } from "../../search/models/paged-data.model";
import { TableRow } from "../../search/models/table-row.model";
import { SearchParams } from "../../search/models/search-params.model";
import { SearchStatus } from "../../search/models/search-status.model";
import { SearchEvent } from "../../search/models/search-event";
import { NEW_SEARCH_EVENT } from "../../search/search-constants";
import { CoreServiceRegistry } from "../../../core/core-service-registry";
import { SharedServiceRegistry } from "../../shared-service-registry";

@Injectable()
export class OrderParameterPopupSearchService extends SearchService {

    public pagedData: PagedData<TableRow>;

    constructor(private coreServiceRegistry: CoreServiceRegistry,
        private sharedServiceRegistry: SharedServiceRegistry,
        public searchParams: SearchParams,
        public searchStatus: SearchStatus) {
        super(coreServiceRegistry.http$, searchParams, searchStatus,
            coreServiceRegistry.resourceService,
            sharedServiceRegistry.userPreferencesService, sharedServiceRegistry.alertService,
            sharedServiceRegistry.dateConfigService);
        this.pagedData = new PagedData<TableRow>();
    }

    @LoaderEnabled()
    public fetchSearchResults(): Observable<Response> {
        this.pagedData.pageRows = [];
        const tableId = this.searchParams.tableId;
        const pageInfoReq = {
            tableId: tableId,
            pageNo: this.pagedData.pageDefinition.pageNumber,
            sortColumn: this.pagedData.pageDefinition.sortColumn,
            sortOrder: this.pagedData.pageDefinition.sortOrder,
            pageSize: this.pagedData.pageDefinition.pageSize,
            fullFetch: this.searchParams.isFullFetch,
            fetchArchiveRecords: this.searchParams.fetchArchiveRecords,
            fetchAllrecords: true
        };
        const payload = {
            pageInfo: pageInfoReq,
            searchCriteria:
                this.formatSearchCriteria(this.searchCriteria, this.searchParams.additionalParamMap, this.filterCondition)
        };
        const dataUrl$: any
            = this.http$.post(`api/data/` + tableId
                + `/loadByPage`, JSON.stringify(payload));
        return dataUrl$
            .map((response: any) => {
                return this.transformSearchResponse(response);
            })
            .catch((errorObject: any) => {
                if (errorObject.error && errorObject.error.errors && errorObject.error.errors[0]) {
                    if (errorObject.error.errors[0].validationCode && errorObject.error.errors[0].validationCode !== 200) {
                        return Observable.throw(this.resourceService.get(errorObject.error.errors[0].validationMessage));
                    } else if (errorObject.status === 400) {
                        return Observable.throw(errorObject.error.errors[0].defaultMessage + ' - ' +
                            errorObject.error.errors['0'].rejectedValue);
                    }
                }
                // JIRA LFWM - 1716 When the user provides any invalid filter value then the previous result data should be cleared
                this.pagedData.pageDefinition.recordCount = 0;
                this.pagedData.pageRows.splice(0, 0);
                this.searchStatus.hasResults = true;
                this.searchStatus.recordCount = 0;
                const event = new SearchEvent(NEW_SEARCH_EVENT);
                event.isSearchSuccess = false;
                this.publishEvent(event);
                // return Observable.throw('Failed to fetch  Search Results :: ' + errorObject.message);
            })
            .finally(() => { });
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/order-parameter-popup/order-parameter-popup-search.service.ts